<template>
    <div style="padding: 0 0 0 55px; margin-top: -64px;">
        <Header />
        <!-- CONTENT -->
        <slot />
    </div>
</template>

<script>
    import Header from "@/components/HeaderComponents.vue";
    import { USER_REQUEST } from "../store/actions/user";

    export default {
        name: "DefaultView",
        components: {
            Header,
        },
        data: () => ({
            active: null
        }),
        created: function() {
            if (this.$store.getters.isAuthenticated) {
            this.$store.dispatch(USER_REQUEST);
            }
        }
    }
</script>
